import TheoLogo from './TheoLogo.jsx';
import OpenChartsLogo from './OpenChartsLogo.jsx';

/* <Footer />
   ----------------------------------------------------------
   Minimal footer: Theo wordmark and a one-line description on
   the left, two product anchor links on the right, and a
   single copyright line below. No company / resources /
   contact columns, no compliance badges. */
const FOOTER_PRODUCTS = [
  { id: 'theo',   href: '#product-theo',   logo: () => <TheoLogo height={18} /> },
  { id: 'charts', href: '#product-charts', logo: () => <OpenChartsLogo height={18} /> },
];

export default function Footer() {
  return (
    <footer className="footer">
      <div className="wrap">
        <div className="foot-grid foot-grid--minimal">
          <div>
            <div className="foot-mark">
              <TheoLogo height={20} />
            </div>
            <p className="foot-blurb">
              The AI engine and the workspace it powers.
            </p>
          </div>
          <div>
            <h5>Products</h5>
            <ul>
              {FOOTER_PRODUCTS.map((p) => (
                <li key={p.id}>
                  <a href={p.href} aria-label={p.id}>
                    {p.logo()}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="foot-bar foot-bar--minimal">
          <div>© 2026 Theo Inc. All rights reserved.</div>
        </div>
      </div>
    </footer>
  );
}
